document.addEventListener('DOMContentLoaded', function () {
    var navButtons = document.querySelectorAll('.History__nav .Button--no-style[data-history-index]');
    var singles = document.querySelectorAll('.History__single[data-history-index]');

    if (!navButtons.length || !singles.length) return;

    // wstrzyknij separatory między przyciski
    navButtons.forEach(function (btn, i) {
        if (i < navButtons.length - 1) {
            var sep = document.createElement('span');
            sep.className = 'History__nav-sep';
            btn.after(sep);
        }
    });

    navButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var index = this.getAttribute('data-history-index');

            navButtons.forEach(function (b) { b.classList.remove('active'); });
            singles.forEach(function (s) { s.classList.remove('active'); });

            this.classList.add('active');

            var target = document.querySelector('.History__single[data-history-index="' + index + '"]');
            if (target) target.classList.add('active');
        });
    });
});